import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import index from '@/components/index'
import file from '@/components/file'
import books from '@/components/books'
import video from '@/components/video'
import required from '@/components/required'
import edit from '@/components/edit'
import exam from '@/components/exam'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/file',
      name: 'file',
      component: file
    },
    {
      path: '/books',
      name: 'books',
      component: books
    },
    {
      path: '/video',
      name: 'video',
      component: video
    },
    {
      path: '/required',
      name: 'required',
      component: required
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam
    },
    {
      path: '/edit',
      name: 'edit',
      component: edit
    }
  ]
})



// WEBPACK FOOTER //
// ./src/page/index.js